// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"2cbbd2fb","108":"20598420","183":"2a4abc3c","338":"c2df575c","453":"4db28bb5","532":"26f87626","748":"7b937547"}[chunkId] + ".chunk.js";
};